<template>
    <div id="PixiBackground">
        <transition name="fade">
            <div ref="pixiAppContainer" v-show="backgroundVisible"></div>
        </transition>
        <main-nav></main-nav>
    </div>
</template>

<script>
    import PixiApp from "@/app/pixi/PixiApp"
    import MainNav from '../components/MainNav'
    import {mapGetters} from "vuex";

    export default {
        name: "PixiBackground",
        components: {
            MainNav
        },
        mounted() {
            this.app = new PixiApp();
            this.app.setup();
            this.$nextTick(() => {
                this.app.init(this.$refs.pixiAppContainer);
            })
        },
        beforeDestroy() {
            this.app.destroy();
        },
        computed: {
            ...mapGetters(["mainNavVisible", "backgroundVisible", "isDragging", "activeIndex"])
        },
        watch: {
            mainNavVisible(isOpen, wasOpen) {
                if (wasOpen) {
                    this.app.backgroundView.openMask();
                } else {
                    this.app.backgroundView.closeMask();
                }
            },
            isDragging(value, prevValue) {
                if (value) {
                    this.app.backgroundView.onHold();
                } else {
                    this.app.backgroundView.onRelease();
                }
            },
            activeIndex(value, prevValue) {
                this.app.backgroundView.setCurrentResource(value);
            },
        }
    }
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/app/components/PixiBackground.vue